import { ReportOption } from "./ReportType";

export class ReportApi {

    private reportRef?: any;

    constructor(reportRef: any) {
        this.reportRef = reportRef;
    }

    /**
     * 设置参数
     * @param option 
     */
    public setOption(option: ReportOption) {
        if (this.reportRef) {
            this.reportRef.setOption(option);
        }
    }

    /**
     * 设置数据
     * @param data 
     */
    public setData(data) {
        if (this.reportRef) {
            this.reportRef.setData(data);
        }
    }

}